<template lang="pug">
  v-row(justify='center', align='center')
    v-col.text-center(cols="12")
      h1 Mapa dinámico
    v-col(cols="12")
      v-row(if="nationalConfirmed")
        v-col(cols="12")
          day-confirmed-chart(:nationalConfirmed='nationalConfirmed')
    v-col(cols="12", xl="6")
      //- v-row(if="nationalConfirmed")
        v-col(cols="12")
          day-confirmed-chart(:nationalConfirmed='nationalConfirmed')
      v-row
        v-col(cols="12", md="6", lg="6", xl="6")
          div Día seleccionado: 
            v-btn(color='primary', dark='', @click.stop='showDialogDays = true')
              div(v-show="daySelected.date") {{daySelected.date | date-format-string}}
              div(v-show="!daySelected.date") Selecciona un día
            v-dialog(v-model='showDialogDays', max-width='290')
              v-card
                v-card-title.headline Selecciona un día:
                v-card-text
                  v-radio-group(v-model='daySelected', :mandatory='false')
                    div(@click='showDialogDays = false')
                      v-radio(v-for="obj in nationalConfirmed", 
                              :label='obj.date | date-format-string', :value='obj')
                v-card-actions
                  v-spacer
                  v-btn(color='green darken-1', text='', @click='showDialogDays = false')
                    | Cerrar
          br
          .row.reducedBlank
            .col-6.reducedBlank
              .v-card.v-card--outlined.v-sheet.theme--light
                .v-list-item--doc.v-list-item.theme--light.primary--text
                  .v-avatar.v-list-item__avatar.red.lighten-2(style='height: 30px; min-width: 30px; width: 30px;')
                    i.v-icon.notranslate.mdi.mdi-plus-thick.theme--dark(aria-hidden='true')
                  .v-list-item__content
                    .v-list-item__title
                      span {{daySelected.confirmed | currency('', 0)}}
                    .v-list-item__subtitle
                      span Confirmados acumulados
            .col-6.reducedBlank
              .v-card.v-card--outlined.v-sheet.theme--light
                .v-list-item--doc.v-list-item.theme--light.primary--text
                  .v-avatar.v-list-item__avatar.red.lighten-2(style='height: 30px; min-width: 30px; width: 30px;')
                    i.v-icon.notranslate.mdi.mdi-skull.theme--dark(aria-hidden='true')
                  .v-list-item__content
                    .v-list-item__title
                      span {{daySelected.deaths | currency('', 0) }} ({{Math.round(daySelected.deaths*100/daySelected.confirmed)}}%)
                    .v-list-item__subtitle
                      span Muertes
          .row
            .col-6.reducedBlank
              .v-card.v-card--outlined.v-sheet.theme--light
                .v-list-item--doc.v-list-item.theme--light.primary--text
                  .v-avatar.v-list-item__avatar.orange.lighten-2(style='height: 30px; min-width: 30px; width: 30px;')
                    i.v-icon.notranslate.mdi.mdi-human-male.theme--dark(aria-hidden='true')
                  .v-list-item__content
                    .v-list-item__title
                      span {{daySelected.confirmedMale | currency('', 0)}} ({{Math.round(daySelected.confirmedMale*100/daySelected.confirmed)}}%)
                    .v-list-item__subtitle
                      span Hombres
            .col-6.reducedBlank
              .v-card.v-card--outlined.v-sheet.theme--light
                .v-list-item--doc.v-list-item.theme--light.primary--text
                  .v-avatar.v-list-item__avatar.orange.lighten-2(style='height: 30px; min-width: 30px; width: 30px;')
                    i.v-icon.notranslate.mdi.mdi-human-female.theme--dark(aria-hidden='true')
                  .v-list-item__content
                    .v-list-item__title
                      span {{daySelected.confirmedFemale | currency('', 0)}} ({{Math.round(daySelected.confirmedFemale*100/daySelected.confirmed)}}%)
                    .v-list-item__subtitle
                      span Mujeres
          .legend-confirmed-cases#legendConfirmed
            .background-legend
              div
            v-row
              v-col.legend-confirmed-cases-title(cols="12")
                div Casos confirmados acumulados
            v-row.text-center(v-for="(obj, i) in styleColorsConfirmed", :key="i")
              v-col(cols="5")
                svg(:width='60/(i+1)', :height='60/(i+1)', xmlns='http://www.w3.org/2000/svg', viewBox="-30,-30,60,60", )
                  path(d='M -25, 0, a 25,25 0 1,1 50,0, a 25,25 0 1,1 -50,0', :fill="styleColorsConfirmed[styleColorsConfirmed.length-1-i]")
              v-col(cols="7")
                v-row.fill-height
                  v-col.vertical-center.legend-confirmed-cases-col(cols="3")
                    div {{(sizeSection*(styleColorsConfirmed.length-1-i))+1 | currency('', 0)}}
                  v-col.vertical-center.legend-confirmed-cases-col(cols="1") - 
                  v-col.vertical-center.legend-confirmed-cases-col(cols="3")
                    div {{sizeSection*((styleColorsConfirmed.length-1-i)+1) | currency('', 0) }}
        v-col(cols="12", xs="12", sm="12", md="6", lg="6", xl="6")
            v-card
              v-card-title.headline.reducedBlank-bottom.reducedBlank-top 
                div Capas temáticas:
                //- v-row
                  v-col(cols="12", sm="5")
                  v-col(cols="12", md="7")
                    div.float-right.align-right(style="font-size: 0.8em;") {{layerSelected.label}}
              v-card-text.reducedBlank-bottom
                //- v-row
                  v-col
                    div.float-right.align-right(style="font-size: 1.2em;") {{layerSelected.label}}
                v-row
                  v-col.reducedBlank-bottom.reducedBlank-top(cols="6")
                    v-radio-group(v-model='layerSelected', :mandatory='false')
                      div(@click='showDialogDays = false')
                        v-radio(v-for="obj in layers", 
                                :label='obj.name', :value='obj')
                  v-col.reducedBlank-bottom.reducedBlank-top(cols="6")
                    //- div leyenda
                    v-row(v-if="layerSelected")
                      v-col.reducedBlank.reducedBlank-bottom.reducedBlank-top
                        div.float-right.align-right {{layerSelected.label}}
                    v-row(v-if="obj.id == layerSelected.id", v-for="(obj, i) in layers", :key='i')
                      v-col
                        v-row(v-for="(objStyle, j) in obj.styles", :key='j')
                          v-col.text-right(style="padding: 2px;")
                            div(v-if="objStyle.value") {{objStyle.value}}
                            div(v-if="!objStyle.value") {{objStyle.min | currency('', 0)}} - {{objStyle.max | currency('', 0)}}
                          v-col(cols="1")(style="padding: 2px;")
                            div(:style="{'background-color': objStyle.color + ' !important', 'color': objStyle.color + ' !important', 'opacity': 0.8}") -
      v-row(if="nationalConfirmed")
        v-col(cols="12")
          #map-canvas
    v-col(cols="12", xl="6")
      v-row(if="nationalConfirmed")
        //- v-col(cols="12")
          day-confirmed-chart(:nationalConfirmed='nationalConfirmed')
        //- v-col(cols="12", lg="6", xl="4")
          new-cases-chart(:nationalConfirmed='nationalConfirmed')
        v-col(cols="12", lg="6")
          age-groups-chart(:daySelected='daySelected')
        v-col(cols="12", lg="6")
          estate-confirmed-chart(:dayInformation='dayInformation')
    v-col(cols="12")
      v-card
        v-card-text
          div Fuentes consultadas:
          div 
            ul
              li Portal de Datos Abiertos de la 
                a(href="https://datos.gob.mx/busca/organization/conapo") CONAPO
                | .
              li Comunicados técnicos diarios publicados por la Secretaría de Salud (Plataforma SISVER, SINAVE, DGE, SSa).
              li
               a(href="https://systems.jhu.edu/research/public-health/ncov/") Repositorio de datos COVID-19
               | del Centro para Sistemas de Ingeniería y Ciencia CSSE (por sus siglas en inglés), de la Universidad Johns Hopkins.
</template>

<script>
/*global google*/

// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

import estates from '@/assets/layers/estates'
import dataService from '@/services/data'

import ageGroupsChart from '@/components/charts/AgeGroups.vue'
import dayConfirmedChart from '@/components/charts/DayConfirmed.vue'
import estateConfirmedChart from '@/components/charts/EstateConfirmed.vue'

import utilService from '@/services/util'

export default {
  name: 'Home',
  components: {
    ageGroupsChart,
    dayConfirmedChart,
    estateConfirmedChart
    // newCasesChart
  },
  data() {
    return {
      layers: [],
      layerSelected: {},
      nationalConfirmed: [],
      daySelected: {},
      estateInformation: [],
      showDialogDays: false,
      dayInformation: [],
      estateMarkers: [],
      styleColorsConfirmed: ['#00ffc5', '#00ffc5', '#00ffc5', '#00ffc5', '#00ffc5'],
      sizeSection: 1
    }
  },
  watch: {
    layerSelected: function() {
      this.reloadDataLayer()
    },
    daySelected: function() {
      this.loadDayInformation()
    }
  },
  methods: {
    initialize() {
      let mapOptions = {
        zoom: 5,
        maxZoom: 7,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        center: new google.maps.LatLng(23.722186353287697, -101.59311750000002),
        panControl: false,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.TOP_RIGHT
        },
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.LARGE,
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        streetViewControl: true,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        fullscreenControl: false
      }

      this.map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions)
      window.map = this.map

      var infowindow = new google.maps.InfoWindow()
      this.infowindow = infowindow

      this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(document.getElementById('legendConfirmed'))

      this.loadLayers()
    },
    loadDaysAvailabled() {
      dataService.listNationalConfirmed().then(res => {
        this.nationalConfirmed = res.object
        if (this.nationalConfirmed.length > 0) {
          this.daySelected = this.nationalConfirmed[0]
        }
      })
    },
    loadDayInformation() {
      dataService.listDayInformaction(this.daySelected).then(res => {
        this.dayInformation = res.object
        this.loadEstateMarkers()
      })
    },
    loadEstateMarkers() {
      if (this.estateMarkers.length > 0) {
        for (let i = 0; i < this.estateMarkers.length; i++) {
          this.estateMarkers[i].setMap(null)
        }
        this.estateMarkers = []
      }
      // let minValue = 0
      let maxValue = 0

      for (let i = 0; i < this.dayInformation.length; i++) {
        if (this.dayInformation[i].confirmed > maxValue) {
          maxValue = this.dayInformation[i].confirmed
        }
      }

      // var myLatLng = {lat: -25.363, lng: 131.044};
      // new google.maps.Marker({
      //   position: myLatLng,
      //   map: this.map,
      //   title: 'Hello World!'
      // });

      let sizeSection = maxValue / this.styleColorsConfirmed.length

      this.sizeSection = sizeSection

      for (let i = 0; i < this.dayInformation.length; i++) {
        let estateObj = utilService.findObjectByKey(estates, 'CVE_ENT', this.dayInformation[i].estateId)
        let slicePart = Math.trunc((this.dayInformation[i].confirmed - 1) / sizeSection)
        let icon = utilService.pinSymbol(this.styleColorsConfirmed[slicePart])
        icon.scale = (slicePart + 1) / this.styleColorsConfirmed.length
        

        let marker = new google.maps.Marker({
          position: { lat: estateObj.coordinates[1], lng: estateObj.coordinates[0] },
          // position: {lat: -25.363, lng: 131.044},
          map: this.map,
          icon: icon,
          title: estateObj.NOM_ENT,
          idEstate: estateObj.CVE_ENT
        })

        marker.addListener('click', () => {
          this.showInfowindow(marker.idEstate, marker, true)
        })

        this.estateMarkers.push(marker)
      }
    },
    loadGoogleApi() {
      this.map = document.createElement('script')
      this.map.type = 'text/javascript'
      this.map.src = `https://maps.google.com/maps/api/js?key=AIzaSyAzRD-eiuevdmKmHG6zMH10KFW8D3cLTXo&libraries=visualization,places,geometry,drawing&language=es&callback=initialize`
      // this.map.src = `https://maps.google.com/maps/api/js?libraries=visualization,places,geometry,drawing&language=es&callback=initialize`
      window.document.body.appendChild(this.map)
    },
    reloadDataLayer() {
      this.map.data.setMap(null)
      this.map.data.setMap(this.map)
    },
    showInfowindow(idEstate, position, isMarker) {
      let estateInfo = null

      for (let i = 0; i < this.dayInformation.length; i++) {
        if (this.dayInformation[i].estateId == idEstate) {
          estateInfo = this.dayInformation[i]
          break
        }
      }

      if (estateInfo) {
        let estateName = ''
        for (let i = 0; i < this.estateMarkers.length; i++) {
          if (this.estateMarkers[i].idEstate == idEstate) {
            estateName = this.estateMarkers[i].title
            break
          }
        }

        let contentHtml = `
            <div class="infowindow-content">
              <p class="infowindow-content-title"><strong>${estateName}</strong></p>
              <p><strong>Confirmados acumulados:</strong>  ${this.$options.filters.currency(
                estateInfo.confirmed,
                '',
                0
              )}</p>
              <p><strong>Hombres:</strong>  ${this.$options.filters.currency(estateInfo.confirmedMale, '', 0)}</p>
              <p><strong>Mujeres:</strong>  ${this.$options.filters.currency(estateInfo.confirmedFemale, '', 0)}</p>
              <p><strong>Muertes:</strong>  ${this.$options.filters.currency(estateInfo.deaths, '', 0)}</p>
            </div>
          `
        // var infowindow = new google.maps.InfoWindow()
        this.infowindow.setContent(contentHtml)
        if (isMarker) {
          this.infowindow.open(this.map, position)
        } else {
          this.infowindow.setPosition(position)
          this.infowindow.open(this.map)
        }
        // window.infowindow = infowindow
      }
    },
    loadLayers() {
      // this.map.data.loadGeoJson('https://storage.googleapis.com/qa-bsi-covid19-layers/estados.geojson')
      // this.map.data.loadGeoJson('http://localhost:8080/dist/layers/estados.geojson')
      // this.map.data.loadGeoJson('./layers/estados.geojson')
      // this.map.data.loadGeoJson('../assets/layers/estados.geojson')
      this.map.data.loadGeoJson('./layers/estados.geojson')
      this.map.data.addListener('click', event => {
        let idEstate = event.feature.getProperty('CVE_ENT')

        this.showInfowindow(idEstate, event.latLng, false)
      })
      // this.map.data.loadGeoJson(estatesGeojson)
      this.layers = [
        {
          id: 1,
          name: 'Población',
          description: '',
          field: 'POBTOT2015',
          label: 'Población total (2015)',
          styles: [
            {
              min: 8918653,
              max: 16187608,
              color: '#CC0000'
            },
            {
              min: 4584472,
              max: 8918652,
              color: '#FF0000'
            },
            {
              min: 2097176,
              max: 4584471,
              color: '#FF9900'
            },
            {
              min: 711235,
              max: 2097175,
              color: '#FFFF00'
            }
          ]
        },
        {
          id: 2,
          name: 'Marginación',
          description: '',
          field: 'GME',
          label: 'Grado de marginación',
          styles: [
            {
              value: 'Muy alto',
              color: '#fe2200'
            },
            {
              value: 'Alto',
              color: '#fe9900'
            },
            {
              value: 'Medio',
              color: '#ffff00'
            },
            {
              value: 'Bajo',
              color: '#7aab01'
            },
            {
              value: 'Muy bajo',
              color: '#1f5d22'
            }
          ]
        },
        {
          id: 3,
          name: 'Hacinamiento',
          description: '',
          field: 'VHAC',
          label: '% de viviendas con hacinamiento',
          styles: [
            {
              min: 36.42,
              max: 44.46,
              color: '#eb2d17'
            },
            {
              min: 28.69,
              max: 36.31,
              color: '#fa9337'
            },
            {
              min: 26.23,
              max: 28.53,
              color: '#fbf561'
            },
            {
              min: 23.62,
              max: 25.65,
              color: '#adc891'
            },
            {
              min: 19.19,
              max: 23.09,
              color: '#4b96b4'
            }
          ]
        }
      ]

      this.map.data.setStyle(obj => {
        let options = {
          fillColor: 'black',
          strokeColor: 'white',
          strokeWeight: 0.5,
          fillOpacity: 0.8,
          icon: './dist/Icono(ico)-04.png'
        }

        if (obj.getProperty('CVE_ENT')) {
          let clave = obj.getProperty('CVE_ENT')
          let estate = estate
          for (let i = 0; i < estates.length; i++) {
            if (clave == estates[i]['CVE_ENT']) {
              estate = estates[i]
              break
            }
          }

          for (let i = 0; i < this.layers.length; i++) {
            if (this.layerSelected.styles[0].value) {
              for (let j = 0; j < this.layerSelected.styles.length; j++) {
                if (this.layerSelected.styles[j].value == estate[this.layerSelected.field]) {
                  options.fillColor = this.layerSelected.styles[j].color
                }
              }
            } else {
              for (let j = 0; j < this.layerSelected.styles.length; j++) {
                if (
                  this.layerSelected.styles[j].min <= estate[this.layerSelected.field] &&
                  estate[this.layerSelected.field] <= this.layerSelected.styles[j].max
                ) {
                  options.fillColor = this.layerSelected.styles[j].color
                  break
                }
              }
            }
          }

          // switch (this.layerSelected) {
          //   case 1 :

          //     break
          // }
        }

        return options
      })
      this.layerSelected = this.layers[1]
    },
    showLayer() {
      // var src = 'https://developers.google.com/maps/documentation/javascript/examples/kml/westcampus.kml';
      // var src = '/assets/layers/IMEF_2015.kmz'
      // var src = '/layers/IMEF_2015.kml'
      // var src = '/layers/westcampus.kml'
      // var src = 'http://localhost:8080/layers/IMEF_2015.kml'
      // var src = 'http://localhost:8080/layers/westcampus.kml'
      // var src = 'https://storage.googleapis.com/qa-bsi-covid19-layers/IMEF_2015.kml'
      // var src = 'https://storage.googleapis.com/qa-bsi-covid19-layers/IMEF_2015.kmz'
      // this.map.data.loadGeoJson('https://storage.googleapis.com/qa-bsi-covid19-layers/estados.geojson')
      // var layer = new google.maps.KmlLayer(src, {
      //   suppressInfoWindows: true,
      //   preserveViewport: false,
      //   map: this.map
      // })
      // layer.addListener('click', function (event) {
      //   var infowindow = new google.maps.InfoWindow()
      //   infowindow.setContent(event.featureData.infoWindowHtml)
      //   infowindow.setPosition(event.latLng)
      //   infowindow.open(this.map)
      //   window.infowindow = infowindow
      // })
      // this.layers = new Map()
      // this.layers.set('marginacion', layer)
      // window.layer = layer
    }
  },
  created() {
    this.map = {}
    window.map = this.map
    this.layerManager = {}

    window.initialize = this.initialize
    window.showLayer = this.showLayer
  },
  mounted() {
    this.loadDaysAvailabled()
    if (!window.google) {
      this.loadGoogleApi()
    } else {
      this.initialize()
    }
  }
}
</script>

<style scoped>
#map-canvas {
  height: 75vh;
}

.legend-confirmed-cases {
  padding-left: 1px;
  margin-left: 2px;
}
.vertical-center {
  margin: auto;
  /* position: absolute; */
  /* -ms-transform: translateY(50%);
  transform: translateY(50%); */
}

.legend-confirmed-cases > .background-legend {
  background-color: white;
  opacity: 0.5;
  position: absolute;
  x: 0;
  y: 0;
  height: 100%;
  width: 110%;
  z-index: -1;
}

.legend-confirmed-cases > .row {
  width: 220px !important;
  margin: 0px;
}

.legend-confirmed-cases > .row > .col {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

.legend-confirmed-cases-col {
  margin-left: 10px;
  padding: 5px;
}

.legend-confirmed-cases-title {
  font-size: 1.4em;
  text-align: center;
}

.reducedBlank {
  /* margin: 2px !important; */
  padding: 2px !important;
}

.reducedBlank-bottom {
  padding-bottom: 1px !important;
}
.reducedBlank-top {
  padding-top: 1px !important;
}
</style>

<style>
.infowindow-content {
  font-size: 1em;
}

.infowindow-content-title {
  font-size: 1.2em;
}
</style>
